import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  ChakraProvider,
  useToast,
  Select,
  HStack,
  Divider,
  Center,
  Switch,
  VStack,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
  fetchSceneriosList,
} from '../Store/GetDropDownsValuesReducer';
import { Form } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { IScenarioItem } from '../Infrastructure/Interfaces';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

const ScenariosModalPopup: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const toast = useToast();
  const { instance, accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;

  const [isScenarioNameReq, setIsScenarioNameReq] = useState(false);
  const [isBillingSystemReq, setIsBillingSystemReq] = useState(false);
  const [isBillingClientReq, setIsBillingClientReq] = useState(false);
  const [isBillingAdminReq, setIsBillingAdminReq] = useState(false);

  const arrregionlist: string[] = (process.env.REACT_APP_REGION_LIST as string).split(',');
  var scenariolist: IScenarioItem[] = useSelector((state: any) => {
    return state.scenariosList.scenariosList;
  });

  const [data, setdata] = useState({
    scenarioid: 0,
    documentid: 0,
    variationid: 0,
    name: '',
    billing_admin: '',
    billing_system: '',
    billing_client: '',
    chart_required: false,
    eob_required: false,
    claim_required: false,
    deliver_option: '',
    deliver_regard: '',
    deliver_to_email_address: '',
    fax_to: '',
    fax_to_faxnumber: '',
    fax_user: '',
    fax_secret: '',
    requestor_first_name: '',
    requestor_last_name: '',
    requestor_phone: '',
    requestor_fax: '',
    requestor_email_address: '',
    requestor_signature: '',
    requestor_company_name: '',
    requestor_company_address1: '',
    requestor_company_address2: '',
    requestor_company_city: '',
    requestor_company_state: '',
    requestor_company_zip: '',
    requestor_alternate_contact: '',
    page_limit: '',
    next_delivery: '',
    upload_channel: '',
    default_channel: false,
  });

  useEffect(() => {
    Store.subscribe(() => {
      setIsScenarioNameReq(false);
      setIsBillingAdminReq(false);
      setIsBillingSystemReq(false);
      setIsBillingClientReq(false);
      setdata({
        ...data,
        scenarioid: Store.getState().setScenariosItem.value.scenarioid,
        documentid: Store.getState().setScenariosItem.value.documentid,
        variationid: Store.getState().setScenariosItem.value.variationid,
        name: Store.getState().setScenariosItem.value.name,
        billing_admin: Store.getState().setScenariosItem.value.billing_admin,
        billing_system: Store.getState().setScenariosItem.value.billing_system,
        billing_client: Store.getState().setScenariosItem.value.billing_client,
        chart_required: Store.getState().setScenariosItem.value.chart_required,
        eob_required: Store.getState().setScenariosItem.value.eob_required,
        claim_required: Store.getState().setScenariosItem.value.claim_required,
        deliver_option: Store.getState().setScenariosItem.value.deliver_option,
        deliver_regard: Store.getState().setScenariosItem.value.deliver_regard,
        deliver_to_email_address:
          Store.getState().setScenariosItem.value.deliver_to_email_address,
        fax_to: Store.getState().setScenariosItem.value.fax_to,
        fax_to_faxnumber:
          Store.getState().setScenariosItem.value.fax_to_faxnumber,
        fax_user: Store.getState().setScenariosItem.value.fax_user,
        fax_secret: Store.getState().setScenariosItem.value.fax_secret,
        requestor_first_name:
          Store.getState().setScenariosItem.value.requestor_first_name,
        requestor_last_name:
          Store.getState().setScenariosItem.value.requestor_last_name,
        requestor_phone:
          Store.getState().setScenariosItem.value.requestor_phone,
        requestor_fax: Store.getState().setScenariosItem.value.requestor_fax,
        requestor_email_address:
          Store.getState().setScenariosItem.value.requestor_email_address,
        requestor_signature:
          Store.getState().setScenariosItem.value.requestor_signature,
        requestor_company_name:
          Store.getState().setScenariosItem.value.requestor_company_name,
        requestor_company_address1:
          Store.getState().setScenariosItem.value.requestor_company_address1,
        requestor_company_address2:
          Store.getState().setScenariosItem.value.requestor_company_address2,
        requestor_company_city:
          Store.getState().setScenariosItem.value.requestor_company_city,
        requestor_company_state:
          Store.getState().setScenariosItem.value.requestor_company_state,
        requestor_company_zip:
          Store.getState().setScenariosItem.value.requestor_company_zip,
        requestor_alternate_contact:
          Store.getState().setScenariosItem.value.requestor_alternate_contact,
        page_limit: Store.getState().setScenariosItem.value.page_limit,
        next_delivery: Store.getState().setScenariosItem.value.next_delivery,
        upload_channel: Store.getState().setScenariosItem.value.upload_channel,
        default_channel:
          Store.getState().setScenariosItem.value.default_channel,
      });
    });
  }, []);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata({
      ...data,
      [id]: value,
    });
    if (
      e.target.id === 'chart_required' ||
      e.target.id === 'eob_required' ||
      e.target.id === 'claim_required'
    ) {
      setdata(prev => ({ ...prev, [id]: e.target.checked }));
    }
    // if(
    //   id === 'deliver_option' && value === 'Fax'
    // ){
    //   setdata(prev => ({ ...prev, 'fax_user': '', 'fax_secret': '' }));
    // }
  };

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();

    if(data.deliver_option !== 'Fax'){
      setdata(prev => ({ ...prev, 'fax_user': '', 'fax_secret': '' }));
    }

    const validationError = validateData(data);
    if (!validationError) {
      return;
    }

    const findname = scenariolist.find((x: { name: string; }) => x.name === data.name);
    if(findname !== undefined && findname.scenarioid != data.scenarioid){
      showToast('Warning!', 'There is already a scenario with the same name. Try some other name.', 'warning')
      return;
    }

    setSaveButtonLoading(true);

    const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Appeal/${
          data.scenarioid > 0 ? 'update_scenario' : 'add_scenario'
        }`;
        const response = await axios.post(url, JSON.stringify(data), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        setSaveButtonLoading(false);
        dispatch(fetchSceneriosList());
        props.onClose();

        if (response.data.success) {
          showToast('Success', response.data.message, 'success');
        }
      }
    } catch (error: any) {
      setSaveButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  function validateData(data: any) {
    const fields = [
      'name',
      'billing_admin',
      'billing_system',
      'billing_client',
    ];
    let isValid = true;

    fields.forEach(field => {
      const isFieldEmpty = data[field].trim() === '';
      if (isFieldEmpty) {
        isValid = false;
      }

      switch (field) {
        case 'name':
          setIsScenarioNameReq(isFieldEmpty);
          break;
        case 'billing_admin':
          setIsBillingAdminReq(isFieldEmpty);
          break;
        case 'billing_system':
          setIsBillingSystemReq(isFieldEmpty);
          break;
        case 'billing_client':
          setIsBillingClientReq(isFieldEmpty);
          break;
      }
    });
    return isValid;
  }

  function showToast(
    title: string,
    description: string,
    status: 'error' | 'success' | 'warning'
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 20000 : 10000,
      isClosable: true,
    });
  }

  return (
    <>
      <ChakraProvider>
        <Modal
          closeOnOverlayClick={false}
          size={'6xl'}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit}>
              <ModalHeader fontWeight="bold" alignSelf="Center">
                <u>Scenarios</u>
              </ModalHeader>
              <ModalCloseButton color="black" />{' '}
              <ModalBody>
                <HStack>
                  <FormControl mt={2} isRequired isInvalid={isScenarioNameReq}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Scenario Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={200}
                      placeholder="name"
                      name="name"
                      id="name"
                      defaultValue={data.name}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Delivery Email:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      name="deliver_to_email_address"
                      id="deliver_to_email_address"
                      defaultValue={data.deliver_to_email_address}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Email:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      name="requestor_email_address"
                      id="requestor_email_address"
                      defaultValue={data.requestor_email_address}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={2} isRequired isInvalid={isBillingSystemReq}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Billing System:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={200}
                      name="billing_system"
                      id="billing_system"
                      defaultValue={data.billing_system}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Fax To:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={50}
                      name="fax_to"
                      id="fax_to"
                      defaultValue={data.fax_to}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Signature:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      name="requestor_signature"
                      id="requestor_signature"
                      defaultValue={data.requestor_signature}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={2} isRequired isInvalid={isBillingAdminReq}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Billing Admin:
                    </FormLabel>
                    <Input
                      size="sm"
                      name="billing_admin"
                      id="billing_admin"
                      defaultValue={data.billing_admin}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Fax Number:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={50}
                      name="fax_to_faxnumber"
                      id="fax_to_faxnumber"
                      defaultValue={data.fax_to_faxnumber}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Company:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={200}
                      name="requestor_company_name"
                      id="requestor_company_name"
                      defaultValue={data.requestor_company_name}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl
                    mt={2}
                    isRequired
                    isInvalid={isBillingClientReq}
                    width="33%"
                  >
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Billing Client:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select billing client--"
                      name="billing_client"
                      id="billing_client"
                      defaultValue={data.billing_client}
                      onChange={e => handleChange(e)}
                    >
                      {arrregionlist?.map(regions => (
                          <option key={regions} value={regions}>
                            {regions}
                          </option>
                        ))}
                    </Select>
                  </FormControl>

                  <FormControl mt={2} width="33%"></FormControl>

                  <FormControl mt={2} width="33%">
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Company Address 1:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={200}
                      name="requestor_company_address1"
                      id="requestor_company_address1"
                      defaultValue={data.requestor_company_address1}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={4} width="33%">
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Chart Required:
                    </FormLabel>
                    <Switch
                      size="sm"
                      isChecked={data.chart_required}
                      name="chart_required"
                      id="chart_required"
                      onChange={e => handleChange(e)}
                    ></Switch>
                  </FormControl>

                  <FormControl mt={2} width="33%"></FormControl>

                  <FormControl mt={2} width="33%">
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Company Address 2:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={200}
                      name="requestor_company_address2"
                      id="requestor_company_address2"
                      defaultValue={data.requestor_company_address2}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={4}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      EOB Required:
                    </FormLabel>
                    <Switch
                      size="sm"
                      name="eob_required"
                      id="eob_required"
                      isChecked={data.eob_required}
                      onChange={e => handleChange(e)}
                    ></Switch>
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor First Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      name="requestor_first_name"
                      id="requestor_first_name"
                      defaultValue={data.requestor_first_name}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Company City:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      name="requestor_company_city"
                      id="requestor_company_city"
                      defaultValue={data.requestor_company_city}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={4}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Claim Required:
                    </FormLabel>
                    <Switch
                      size="sm"
                      name="claim_required"
                      id="claim_required"
                      isChecked={data.claim_required}
                      onChange={e => handleChange(e)}
                    ></Switch>
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Last Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      name="requestor_last_name"
                      id="requestor_last_name"
                      defaultValue={data.requestor_last_name}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Company State:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      name="requestor_company_state"
                      id="requestor_company_state"
                      defaultValue={data.requestor_company_state}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={2} isRequired>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Delivery Option:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="deliver_option"
                      id="deliver_option"
                      defaultValue={data.deliver_option}
                      onChange={e => handleChange(e)}
                    >
                      <option value="Fax">Fax</option>
                      <option value="Print">Print</option>
                      <option value="Upload">Upload</option>
                      <option value="Availity Upload">Availity Upload</option>
                      <option value="UHC Upload">UHC Upload</option>
                    </Select>
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Phone:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={12}
                      name="requestor_phone"
                      id="requestor_phone"
                      defaultValue={data.requestor_phone}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Company Zip:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={20}
                      name="requestor_company_zip"
                      id="requestor_company_zip"
                      defaultValue={data.requestor_company_zip}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack hidden={data.deliver_option != 'Fax' ? true : false}>
                  <FormControl mt={2} width="33%">
                    <FormLabel fontSize="xs" fontWeight="bold">
                      RightFax User:
                    </FormLabel>
                    <Input
                      size="sm"
                      name="fax_user"
                      id="fax_user"
                      value={data.fax_user}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack hidden={data.deliver_option != 'Fax' ? true : false}>

                  <FormControl mt={2} width="33%">
                    <FormLabel fontSize="xs" fontWeight="bold">
                      RightFax Password:
                    </FormLabel>
                    <Input
                      size="sm"
                      name="fax_secret"
                      id="fax_secret"
                      value={data.fax_secret}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Delivery Message:
                    </FormLabel>
                    <Input
                      size="sm"
                      name="deliver_regard"
                      id="deliver_regard"
                      defaultValue={data.deliver_regard}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Fax:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={12}
                      name="requestor_fax"
                      id="requestor_fax"
                      defaultValue={data.requestor_fax}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl mt={2}>
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Requestor Alternate Contact:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={12}
                      name="requestor_alternate_contact"
                      id="requestor_alternate_contact"
                      defaultValue={data.requestor_alternate_contact}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>

                <HStack>
                  <FormControl mt={2} width="33%">
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Next Delivery Option:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="None"
                      name="next_delivery"
                      id="next_delivery"
                      defaultValue={data.next_delivery}
                      onChange={e => handleChange(e)}
                    >
                      <option value="Print">Print</option>
                    </Select>
                  </FormControl>

                  <FormControl width="33%"></FormControl>

                  <FormControl mt={2} width="33%" float="right">
                    <FormLabel fontSize="xs" fontWeight="bold">
                      Page Limit:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={3}
                      type="number"
                      name="page_limit"
                      id="page_limit"
                      defaultValue={data.page_limit ? data.page_limit : 50}
                      onChange={e => handleChange(e)}
                    />
                  </FormControl>
                </HStack>
              </ModalBody>
              <ModalFooter>
                <Button bg="#002677" color="white" onClick={props.onClose}>
                  Cancel
                </Button>
                <Spacer />
                <Button
                  isLoading={saveButtonLoading}
                  bg="#002677"
                  color="white"
                  mr={3}
                  type="submit"
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};

export default ScenariosModalPopup;
